import { render, staticRenderFns } from "./CoachHomeDashboard.vue?vue&type=template&id=6a80fcee&scoped=true&"
import script from "./CoachHomeDashboard.vue?vue&type=script&lang=js&"
export * from "./CoachHomeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CoachHomeDashboard.vue?vue&type=style&index=0&id=6a80fcee&prod&scoped=true&lang=css&"
import style1 from "./CoachHomeDashboard.vue?vue&type=style&index=1&id=6a80fcee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a80fcee",
  null
  
)

export default component.exports